import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_LIST_QUERY = graphql(/* GraphQL */ `
  query NegotiationCaseList(
    $offset: Int
    $limit: Int
    $filter: TsrctQueryBuilderQuery
    $order: [TsrctNegotiationCaseOrder!]
  ) {
    tesseract {
      negotiationCases(offset: $offset, limit: $limit, filter: $filter, order: $order) {
        nodes {
          id
          isMaskedBidding
          sequenceNumber
          createdAt
          updatedAt
          issuesCompletedCount
          issuesOpenCount
          issuesTotalCount
          totalValue
          totalDiscountedValue
          totalPriceDiscount
          discount
          currency
          organizationId
          demandId
          demandSequenceNumber
          referenceId
          responsibleIds
          status
          processStatus
          cancellationReason
          cancellationReasonText
          supplierAddress
          supplierCity
          supplierContactEmail
          supplierContactFirstName
          supplierContactLastName
          supplierContactPhone
          supplierCountryCode
          supplierId
          supplierExternalReference
          supplierName
          supplierPostalCode
          negotiationBoundaryUpper
          negotiationBoundaryLower
          hasSupplierComment
          latestCommentAuthorId
          latestCommentCreatedAt
          latestCommentMessage
        }
        totalCount
      }
    }
  }
`);
